import { Component } from '@angular/core';

import { DemoFormComponent } from '../../../shared/components/demo-form/demo-form.component';

@Component({
  selector: 'vx-contact-page',
  standalone: true,
  imports: [DemoFormComponent],
  template: `
    <section class="text-page">
      <article class="content-card">
        <h1>Contatti / Demo</h1>
        <p>È possibile manifestare interesse per partnership strategiche o ricevere aggiornamenti sull’apertura del primo sito pilota.</p>
        <p>Richiedi una demo</p>
        <vx-demo-form />
      </article>
    </section>
  `,
  styles: [`
    .text-page {
      min-height: calc(100vh - 78px);
      padding: 18px 0;
      color: #21094f;
      background: #40286a;
    }
    .content-card {
      width: min(806px, calc(100% - 32px));
      margin: 0 auto;
      padding: 24px 24px 28px;
      border-radius: 9px;
      background: #f4effc;
    }
    h1 {
      margin: 0 0 16px;
      font-family: "Space Grotesk", sans-serif;
      font-size: clamp(1.8rem, 4vw, 2rem);
    }
    p {
      margin: 18px 0;
      font-size: 1.05rem;
      font-weight: 800;
      line-height: 1.5;
    }
  `]
})
export class ContactPageComponent {}
